const GlueLogo = ({ width = 150, height = 40 }) => {
  const styles = {
    width: `${width}px`,
    height: `${height}px`,
    backgroundImage: `url('/images/logo.svg')`, // Ensure the SVG is in the public folder
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    backgroundPosition: 'center',
    display: 'inline-block',
  };

  return <div style={styles} />;
};

export default GlueLogo;
